const exportedObject = {
  consultarReportesData: {},
  consultarReportesLoading: false,
  consultarReportesError: null,

  exportarReportesExcelData: null,
  exportarReportesExcelLoading: false,
  exportarReportesExcelError: null
};

export default exportedObject;
